import React from "react";
import CognitoForm from "../components/cognitoFormSlice";

const FooterBanner = ({ data }) => {

  const fbData = data.primary;

  const overlayMap = {
    "None": "rgba(0, 0, 0, 0)",
    "Light": "rgba(0, 0, 0, 0.3)",
    "Medium": "rgba(0, 0, 0, 0.65)",
    "Dark": "rgba(0, 0, 0, 0.85)"
  };

  const overlayColor = overlayMap[fbData.footer_banner_background_overlay] || "rgba(0, 0, 0, 0)";

  return (
    <section className="fbSection" id="fbSection" style={{ position: "relative", background: `url(${fbData.footer_banner_background.url})`, backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center center" }}>
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: overlayColor, zIndex: 1 }}></div>
      <div className="fbContentWrapper" style={{ position: "relative", zIndex: 2 }}>
        {fbData.include_footer_form && fbData.footer_form_id ? (
          <>
            <div className="fbFormContentWrapper">
              <h2 className="fbHeader">
                {fbData.footer_banner_header[0].text}
              </h2>
              <h3 className="fbDescription">
                {fbData.footer_banner_description}
              </h3>
            </div>
            <div className="fbFormWrapper">
              <CognitoForm 
                id={fbData.footer_form_id}
                formName={fbData.footer_form_name}
                customTag={fbData.footer_form_custom_tag}
              />
            </div>
          </>
        ) : (
          <>
            <h2 className="fbHeader">
              {fbData.footer_banner_header[0].text}
            </h2>
            <h3 className="fbDescription">
              {fbData.footer_banner_description}
            </h3>
          </>
        )}
      </div>
    </section>
  )
}

export default FooterBanner;